/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner } from './get-current-card-associated-with-the-user-account200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetCurrentCardAssociatedWithTheUserAccount200ResponseReissue } from './get-current-card-associated-with-the-user-account200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { GetCurrentCardAssociatedWithTheUserAccount200ResponseUser } from './get-current-card-associated-with-the-user-account200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup } from './get-current-card-associated-with-the-user-account200-response-user-account-group';

/**
 * 
 * @export
 * @interface GetCurrentCardAssociatedWithTheUserAccount200Response
 */
export interface GetCurrentCardAssociatedWithTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'availableCurrencies': Array<GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'availableMerchantCategories': Array<GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetCurrentCardAssociatedWithTheUserAccount200ResponseUser}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'user': GetCurrentCardAssociatedWithTheUserAccount200ResponseUser;
    /**
     * 
     * @type {GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'userAccountGroup'?: GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {GetCurrentCardAssociatedWithTheUserAccount200ResponseReissue}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'reissue'?: GetCurrentCardAssociatedWithTheUserAccount200ResponseReissue | null;
}

export const GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum = typeof GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum];


